var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "th",
    {
      class: [_vm.$style["mds-th"], _vm.classObject],
      attrs: { "aria-sort": _vm.ariaSort, scope: "col" },
    },
    [
      _vm.hasDefaultSlot
        ? _c(
            "div",
            { class: _vm.$style["mds-th__inner"] },
            [
              _vm.sortable
                ? [
                    _c(
                      "button",
                      {
                        class: _vm.$style["mds-th__button"],
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.emitSortFieldChange($event)
                          },
                        },
                      },
                      [_vm._t("default")],
                      2
                    ),
                  ]
                : _c(
                    "span",
                    { class: _vm.$style["mds-th__text"] },
                    [_vm._t("default")],
                    2
                  ),
              _vm._v(" "),
              _vm.hasActionSlot
                ? _c(
                    "span",
                    { class: [_vm.$style["mds-th__action"]] },
                    [_vm._t("mds-th-actions")],
                    2
                  )
                : _vm._e(),
            ],
            2
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }